import { salesReportsAccionesRoles } from '../../acciones-roles/other-accione-roles/sales-reports-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton1,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';
export const SalesReportsRoutes: SideBarButton = {
  data: {
    name: 'Sales Reports',
  },
  options: PreConfigButton1,
  icon: 'summarize',
  butons: [
    {
      data: {
        name: 'Workbook',
        url: '/reportsPBI/sales/workbook',
        roles: salesReportsAccionesRoles.sideNavActions.salesReportsWorkbook,
      },
      options: PreConfigButton3,
    },
  ],
};
